import publicUrls from "../../../routes/publicUrls";
import React from "react";
import { Box, Typography } from "@mui/material";

import Section from "../../../components/gallery/Section";
import { tokens } from "../../../theme/galleryTheme";



const QUICK_LINKS = [
  { label: "Upcoming auctions", href: "/auctions" },
  { label: "Exhibitions", href: publicUrls.exhibitions() },
  { label: "Private sales", href: publicUrls.privateSales() },
  { label: "How to buy", href: "/how-to-buy" },
  { label: "Sell with us", href: "/how-to-sell" },
];

export default function IntroSection() {
  return (
    <Section labelledBy="home-intro-title" sx={{ py: { xs: 6, md: 9 } }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(0, 7fr) minmax(0, 4fr)" },
          gap: { xs: 5, md: 10 },
          alignItems: "end",
        }}
      >
        <Box sx={{ display: "grid", gap: 2 }}>
          <Typography variant="overline" component="p">
            Fine art auctions · Exhibitions · Private sales
          </Typography>
          <Typography id="home-intro-title" variant="h1" component="h1" sx={{ color: tokens.color.ink }}>
            León Gallery
          </Typography>
          <Typography variant="body1" sx={{ fontSize: { xs: "1.0625rem", md: "1.1875rem" }, maxWidth: "58ch" }}>
            The Philippines’ most trusted auction house. Specialists in culturally important and
            museum-quality Philippine art, and purveyors of fine Philippine antiques and historical
            objects.
          </Typography>
        </Box>

        <Box component="nav" aria-label="Explore León Gallery">
          <Box component="ul" sx={{ listStyle: "none", m: 0, p: 0, borderTop: `1px solid ${tokens.color.line}` }}>
            {QUICK_LINKS.map((link) => (
              <Box component="li" key={link.href} sx={{ borderBottom: `1px solid ${tokens.color.line}` }}>
                <Box
                  component="a"
                  href={link.href}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    minHeight: 52,
                    color: tokens.color.ink,
                    textDecoration: "none",
                    fontSize: "1rem",
                    fontWeight: 500,
                    "& .lg-arrow": { transition: "transform 0.2s ease", color: tokens.color.muted },
                    "&:hover": { textDecoration: "underline", textUnderlineOffset: "4px" },
                    "&:hover .lg-arrow": { transform: "translateX(4px)", color: tokens.color.ink },
                  }}
                >
                  {link.label}
                  <span className="lg-arrow" aria-hidden="true">
                    →
                  </span>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Section>
  );
}
